/* eslint-disable no-param-reassign */
import { type Route } from 'router5';

type Params = Record<string, any>;

const paramsWithPrefix = [
  'profile',
  'initiative',
  'username',
  'customerSlug',
  'spacePath',
];

// const doNotEncodeParams = ['fileID', 'shareFileId', ...];

export const encodeParams = (stateParams: Params) => {
  const encodedStateParams: Params = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(stateParams)) {
    if (value === undefined || value === null) {
      console.warn(`EncodeParams found ${value} in param:`, key);
      encodedStateParams[key] = value;
    } else if (key === 'basepath') {
      encodedStateParams[key] = value
        .split('/')
        .map(encodeURIComponent)
        .join('/');
    } else if (key === 'slug') {
      encodedStateParams[key] = encodeURIComponent(value);
    } else if (paramsWithPrefix.includes(key)) {
      encodedStateParams[key] = value[0] + encodeURIComponent(value.slice(1));
    } else {
      encodedStateParams[key] = value;
    }
  }
  return encodedStateParams;
};

export const decodeParams = (pathParams: Params) => {
  const decodedPathParams: Params = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(pathParams)) {
    if (key === 'basepath') {
      decodedPathParams[key] = value
        .split('/')
        .map(decodeURIComponent)
        .join('/');
    } else if (key === 'slug') {
      decodedPathParams[key] = decodeURIComponent(value);
    } else if (paramsWithPrefix.includes(key)) {
      decodedPathParams[key] = value[0] + decodeURIComponent(value.slice(1));
    } else {
      decodedPathParams[key] = value;
    }
  }
  return decodedPathParams;
};

// As per documentation https://router5.js.org/guides/defining-routes
// Note on encodeParams and decodeParams: one can't be used without another,
// and applying one after another should be equivalent to an identity function.
export const applyEncodingDecodingToAllRoutes = (routes: Route[]) => {
  routes.forEach(route => {
    route.decodeParams = decodeParams;
    route.encodeParams = encodeParams;
    if (route.children) {
      applyEncodingDecodingToAllRoutes(route.children);
    }
  });
};
